// Wat elke dienst in src/api gemeen heeft. (WI5)
//
// Hoe het was: elke dienst had twintig regels omheen die overal hetzelfde deden -- een controle op
// ontbrekende gegevens, een logregel, een try, een catch die de fout naar Sentry stuurde en daarna
// `null` teruggaf, en een melding bij succes. Dat gaf drie problemen:
//
//   1. `null` bij een fout. 141 keer. De aanroeper las daarna iets van niets en kreeg een tweede,
//      onbegrijpelijke fout in plaats van de echte. De 500 of de time-out die er werkelijk was,
//      verdween.
//   2. 78 meldingen bij succes. `captureEvent` maakt een volwaardige Sentry-gebeurtenis, dus bij
//      elke gast die een widget opent gingen er tien tot twintig de deur uit. Je quota ging op aan
//      "het is goed gegaan" en de echte fouten verzopen daarin.
//   3. Twintig regels omhaal per dienst maakte niet zichtbaar wat een dienst nu eigenlijk doet.
//
// Wat er voor in de plaats komt: een dienst zegt wat hij nodig heeft, zegt wat hij ophaalt, en doet
// dat. Gaat er iets mis, dan gooit hij en handelt de aanroeper het af -- die weet als enige wat de
// gast op dat moment hoort te zien. Het naar Sentry sturen gebeurt al in de onderschepper van
// axios, op een plek, met de status en het adres erbij.
import { logInfo } from '../utils/sentryUtils';

/**
 * Controleert dat de dienst heeft wat hij nodig heeft, en zegt anders precies wat er mist.
 *
 * Hier stond een console.error en daarna `return null`, waarna de aanroeper alsnog struikelde over
 * iets wat niet bestond. Nu valt hij om op de plek waar het misgaat en met de naam van wat er mist.
 */
export function vereist(dienst, waarden) {
    const mist = Object.entries(waarden)
        .filter(([, waarde]) => waarde === undefined || waarde === null || waarde === '')
        .map(([naam]) => naam);

    if (mist.length > 0) {
        throw new Error(dienst + ': ' + mist.join(' en ') + ' ontbreekt');
    }
}

/**
 * Een regel in het spoor naar Sentry, zodat je bij een fout ziet wat eraan voorafging.
 *
 * Dit is een kruimel en geen gebeurtenis: hij kost geen quota en verschijnt alleen in het spoor
 * onder een echte fout.
 */
export function spoor(bericht, gegevens) {
    logInfo(bericht, gegevens);
}
